import { useEffect, useRef, useState } from 'react';
import { client } from './axios';
import ConfettiExplosion from 'react-confetti-explosion';
import { FontBase } from './font-base';
import { labels } from './labels';

export function Score() {
  const [data, setData] = useState<any>(null);
  const [language, setLanguage] = useState<'eng' | 'swe'>('swe');
  const scoreIntervalRef = useRef<any>(null);
  const getScore = async () => {
    try {
      const response = await client.get('/gothiacup/score');
      if (response.data === '') {
        setData(null);
        return;
      }
      const { score, player, id, language } = response.data;
      setLanguage(language);
      setData({ score, player, id });
      const timeout = setTimeout(() => {
        setData(null);
        clearTimeout(timeout);
      }, 8000);
    } catch (error) {
      setData(null);
    }
  };
  useEffect(() => {
    const cleanup = () => {
      if (scoreIntervalRef.current) {
        clearInterval(scoreIntervalRef.current);
      }
    };
    //Fetch the latest score every 5 seconds
    scoreIntervalRef.current = setInterval(getScore, 8000);
    return cleanup;
  }, []);

  return (
    <div className="w-screen h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat bg-zinc-900 text-white ">
      <FontBase />
      <img src="https://jirangopub.s3.eu-north-1.amazonaws.com/Files/9962/SEB_Wordmark_RGB_White.svg" className="h-12 absolute top-8 left-8" alt="SEB" />
      {data && (
        <div className="text-center flex flex-col gap-4">
          <h1 className="font-bold text-7xl ">
            {labels['congrats'][language]} {data.player}!
          </h1>
          <h2 className="font-bold text-9xl ">{data.score?.substring(0, 8)}</h2>
          <div className="fixed left-1/2 -translate-x-1/2">
            <ConfettiExplosion force={0.8} duration={3000} particleCount={500} width={2000} height={'120vh'} />
          </div>
        </div>
      )}
    </div>
  );
}
